import {FC} from 'react';
import {hasValue, IRecordStructureMessage} from '@kcast-fe/core';
import {Box, Center, Flex, Grid} from '@chakra-ui/react';
import {Svg} from '@kcast-fe/ui-kit';

import {RoleSlot, TextSlot, ToolSlot} from './components';

interface IProps {
  messages: IRecordStructureMessage[];
}

export const MessagesTab: FC<IProps> = ({messages}) => {
  return (
    <Box pt={'12px'}>
      {messages.map((m, i) => {
        return (
          <Flex key={i} flexDirection={'column'}>
            <Grid gridTemplateColumns={'100px 1fr'}>
              {/* ROLE NAME */}
              <RoleSlot name={m.role} />

              <Flex flexDirection={'column'} gap={'12px'} minW={0}>
                {/* RENDER TEXT */}
                {m.blocks
                  .filter((b) => hasValue(b.text))
                  .map((b, bi) => {
                    return <TextSlot key={bi} role={m.role} type={b.type} text={b.text} />;
                  })}

                {/* RENDER TOOL CALL */}
                {m.tool_calls?.map((t, ti) => {
                  return <ToolSlot key={ti} name={t.name} args={t.args} />;
                })}
              </Flex>
            </Grid>

            {messages.length - 1 !== i && (
              <Box w={'100px'} py={'6px'}>
                <Center opacity={0.5} color={'{colors.textTertiary}'}>
                  <Svg name={'Plus'} size={'s20'} />
                </Center>
              </Box>
            )}
          </Flex>
        );
      })}
    </Box>
  );
};
